const backofficeRoutes = [
  {
    path: '/backoffice/solicitacao/:solicitacaoId',
    name: 'backoffice-surgery-solicitation-details',
    view: 'backoffice-surgery-solicitation-details',
    meta: {
      isPublic: false,
      showMenu: false,
      isAuthorized: true,
      permissao: 'agendamento.backoffice.solicitacao.visualizar',
    },
  },
  {
    path: '/backoffice/tabelas-referencia',
    name: 'BackofficeTabelasReferencia',
    view: 'calculo-tabela-referencia',
    meta: {
      showMenu: false,
      isAuthorized: true,
      keyAuthorized: 'backoffice-calculo-tabela-referencia',
    },
  },
  {
    path: '/backoffice/producao',
    name: 'BackofficeProducao',
    view: 'backoffice-producao',
    meta: {
      showMenu: false,
      isAuthorized: true,
      keyAuthorized: 'backoffice-producao',
    },
  },
  {
    path: '/backoffice/contratos/:id',
    name: 'BackofficeContratosDetails',
    view: 'backoffice-contratos-details',
    meta: {
      showMenu: false,
      keyAuthorized: 'backoffice-contratos',
    },
  },
]

const financeiroRoutes = [
  {
    path: '/financeiro-calculo-remuneracao',
    name: 'financeiroCalculoRemuneracao',
    view: 'financeiro-calculo-remuneracao',
    meta: {
      showMenu: false,
      keyAuthorized: 'backoffice-calculo-validacao',
    },
  },
  {
    path: '/financeiro-producao-disponivel-calculo',
    name: 'financeiroProducaoDisponivelCalculo',
    view: 'financeiro-producao-disponivel-calculo',
    meta: {
      showMenu: false,
      keyAuthorized: 'financeiro-geracao-de-repasses',
    },
  },
  {
    path: '/financeiro-tabela-amb',
    name: 'financeiroTabelaAmb',
    view: 'financeiro-tabela-amb',
    meta: {
      showMenu: false,
      keyAuthorized: 'backoffice-calculo-tabela-ambtuss',
    },
  },
  {
    path: '/financeiro-agenda-minima-garantia-periodo',
    name: 'financeiroAgendaMinimaGarantiaPeriodo',
    view: 'financeiro-agenda-minima-garantia-periodo',
    meta: {
      showMenu: false,
      keyAuthorized: 'financeiro-agenda-minima-garantia-periodo',
    },
  },
  {
    path: '/financeiro-carga-logs',
    name: 'financeiroCargaLogs',
    view: 'financeiro-carga-logs',
    meta: {
      showMenu: false,
      keyAuthorized: 'financeiro',
    },
  },
  {
    path: '/financeiro-notificar-email',
    name: 'financeiroNotificarEmail',
    view: 'financeiro-notificar-email',
    meta: {
      showMenu: false,
      keyAuthorized: 'financeiro-notificar-email',
    },
  },
  {
    path: '/financeiro-tabela-feriados',
    name: 'financeiroTabelaFeriados',
    view: 'financeiro-tabela-feriados',
    meta: {
      showMenu: false,
      keyAuthorized: 'financeiro-feriado',
    },
  },
  {
    path: '/financeiro-monitor-integracao',
    name: 'financeiroMonitorIntegracao',
    view: 'financeiro-monitor-integracao',
    meta: {
      showMenu: false,
      keyAuthorized: 'financeiro-monitor-integracao',
    },
  },
  {
    path: '/financeiro-calculo-teto',
    name: 'financeiroCalculoTeto',
    view: 'financeiro-calculo-teto',
    meta: {
      showMenu: false,
      keyAuthorized: 'financeiro-calculo-teto-global',
    },
  },
  {
    path: '/financeiro-tabela-propria',
    name: 'financeiroTabelaPropria',
    view: 'financeiro-tabela-propria',
    meta: {
      showMenu: false,
      keyAuthorized: 'financeiro-tabela-propria',
    },
  },
  {
    path: '/financeiro-upload-nota-fiscal/:prestadorRecebimentoId',
    name: 'FinanceiroUploadNotaFiscal',
    view: 'financeiro-upload-nota-fiscal',
    meta: {
      isPublic: true,
      showMenu: false,
      isAuthorized: true,
    },
  },
  {
    path: '/financeiro-backoffice/chat',
    name: 'FinanceiroBackofficeChat',
    view: 'financeiro-backoffice-chat/financeiro-backoffice-chat-list',
    meta: {
      showMenu: false,
      keyAuthorized: 'backoffice-chat-remuneracao',
    },
  },
  {
    path: '/financeiro-agrupamentos',
    name: 'financeiroAgrupamentos',
    view: 'financeiro-agrupamentos',
    meta: {
      showMenu: false,
      keyAuthorized: 'financeiro',
    },
  },
  {
    path: '/financeiro-especialidade',
    name: 'financeiroEspecialidade',
    view: 'financeiro-especialidade',
    meta: {
      showMenu: false,
      keyAuthorized: 'financeiro-especialidade',
    },
  },
  {
    path: '/financeiro-transacao-financeira',
    name: 'financeiroTransacaoFinanceira',
    view: 'financeiro-transacao-financeira',
    meta: {
      showMenu: false,
      keyAuthorized: 'financeiro',
    },
  },
  {
    path: '/financeiro-centro-de-custo',
    name: 'financeiroCentroDeCusto',
    view: 'financeiro-centro-de-custo',
    meta: {
      showMenu: false,
      keyAuthorized: 'financeiro',
    },
  },
  {
    path: '/financeiro-operadora-hospital',
    name: 'financeiroOperadoraHospital',
    view: 'financeiro-operadora-hospital',
    meta: {
      showMenu: false,
      keyAuthorized: 'financeiro',
    },
  },
]

const configuracaoRoutes = [
  {
    path: '/configuracoes/pessoa',
    name: 'ConfiguracaoPessoa',
    view: 'configuracao-pessoa',
    meta: {
      showMenu: false,
      keyAuthorized: 'solicitacao-cirurgia',
    },
  },
  {
    path: '/configuracoes/solicitacao-cirurgia',
    name: 'ConfiguracaoSolicitacaoCirurgia',
    view: 'configuracao-solicitacao-cirurgia/configuracao-solicitacao-cirurgia',
    meta: {
      showMenu: false,
      keyAuthorized: 'solicitacao-cirurgia',
    },
  },
  {
    path: '/configuracoes/integracao-operadora',
    name: 'ConfiguracaoIntegracaoOperadora',
    view: 'configuracao-integracao-operadora',
    meta: {
      showMenu: false,
      keyAuthorized: 'solicitacao-cirurgia',
    },
  },
]

const suporteRoutes = [
  {
    path: '/suporte/personificar',
    name: 'SuportePersonificar',
    view: 'suporte-personificar',
    meta: {
      showMenu: false,
      keyAuthorized: 'suporte-personificar',
    },
  },
  {
    path: '/suporte/pacientes',
    name: 'SuportePacientes',
    view: 'suporte-pacientes',
    meta: {
      showMenu: false,
      keyAuthorized: 'suporte',
    },
  },
  {
    path: '/suporte/equipamentos',
    name: 'SuporteEquipamentos',
    view: 'suporte-equipamentos',
    meta: {
      showMenu: false,
      keyAuthorized: 'suporte',
    },
  },
  {
    path: '/suporte/fornecedores',
    name: 'SuporteFornecedores',
    view: 'suporte-fornecedores',
    meta: {
      showMenu: false,
      keyAuthorized: 'suporte',
    },
  },
  {
    path: '/suporte/convenios',
    name: 'SuporteConvenios',
    view: 'suporte-convenios',
    meta: {
      showMenu: false,
      keyAuthorized: 'suporte',
    },
  },
  {
    path: '/suporte/procedimentos',
    name: 'SuporteProcedimentos',
    view: 'suporte-procedimentos',
    meta: {
      showMenu: false,
      keyAuthorized: 'suporte',
    },
  },
  {
    path: '/suporte/caixas-cirurgicas',
    name: 'SuporteCaixasCirurgicas',
    view: 'suporte-caixas-cirurgicas',
    meta: {
      showMenu: false,
      keyAuthorized: 'suporte',
    },
  },
  {
    path: '/suporte/anestesistas',
    name: 'SuporteAnestesistas',
    view: 'suporte-anestesistas',
    meta: {
      showMenu: false,
      keyAuthorized: 'suporte',
    },
  },
  {
    path: '/suporte/atualizacao-de-pdf',
    name: 'SuporteAtualizacaoDePdf',
    view: 'suporte-atualizacao-de-pdf',
    meta: {
      showMenu: false,
      keyAuthorized: 'suporte',
    },
  },
  {
    path: '/suporte/feedback',
    name: 'SuporteFeedback',
    view: 'suporte-feedback',
    meta: {
      showMenu: false,
      keyAuthorized: 'suporte',
    },
  },
  {
    path: '/suporte/salas-centros-cirurgicos',
    name: 'SuporteSalasCentrosCirurgicos',
    view: 'suporte-salas-centros-cirurgicos',
    meta: {
      showMenu: false,
      keyAuthorized: 'suporte',
    },
  },
  {
    path: '/suporte/motivo-cancelamento',
    name: 'SuporteMotivoCancelamento',
    view: 'suporte-motivo-cancelamento',
    meta: {
      showMenu: false,
      keyAuthorized: 'suporte',
    },
  },
  {
    path: '/suporte/motivo-transferencia-reserva',
    name: 'SuporteMotivoTransferenciaSala',
    view: 'suporte-motivo-transferencia-reserva',
    meta: {
      showMenu: false,
      keyAuthorized: 'suporte',
    },
  },
  {
    path: '/suporte/procedimentos-apenas-hospital-dia',
    name: 'SuporteProcedimentosApenasHospitalDia',
    view: 'suporte-procedimentos-apenas-hospital-dia',
    meta: {
      showMenu: false,
      keyAuthorized: 'suporte',
    },
  },
  {
    path: '/suporte/tipo-acomodacao',
    name: 'SuporteTipoAcomodacao',
    view: 'suporte-tipo-acomodacao',
    meta: {
      showMenu: false,
      keyAuthorized: 'suporte',
    },
  },
  {
    path: '/suporte/alterar-situacao-solicitacao',
    name: 'SuporteAlterarSituacaoSolicitacao',
    view: 'suporte-alterar-situacao-solicitacao',
    meta: {
      showMenu: false,
      keyAuthorized: 'suporte',
    },
  },
  {
    path: '/suporte/paises',
    name: 'SuportePaises',
    view: 'suporte-paises',
    meta: {
      showMenu: false,
      keyAuthorized: 'suporte',
    },
  },
  {
    path: '/suporte/secretarias',
    name: 'SuporteSecretarias',
    view: 'suporte-secretarias',
    meta: {
      showMenu: false,
      keyAuthorized: 'suporte',
    },
  },
  {
    path: '/suporte/convites',
    name: 'SuporteConvites',
    view: 'suporte-convites',
    meta: {
      showMenu: false,
      keyAuthorized: 'suporte',
    },
  },
  {
    path: '/suporte/salas-roboticas',
    name: 'SuporteSalasRoboticas',
    view: 'suporte-salas-roboticas',
    meta: {
      showMenu: false,
      keyAuthorized: 'suporte',
    },
  },
]

const relatorioRoutes = [
  {
    path: '/relatorio/:typeReport?/:detail?',
    name: 'relatorio',
    view: 'relatorio/relatorio',
    meta: {
      showMenu: true,
      keyAuthorized: 'relatorio',
    },
  },
  {
    path: '/relatorio/detalhe/:type/:fontePagadoraId/operadora/:operadoraId/:initialDate/:finalDate',
    name: 'relatorio-detalhes/relatorio-detalhes-operadora',
    view: 'relatorio-detalhes/relatorio-detalhes',
    meta: {
      keyAuthorized: 'relatorio',
    },
  },
  {
    path: '/relatorio/detalhe/:type/:operadoraId/local-execucao/:localExecucaoId/:initialDate/:finalDate',
    name: 'relatorio-detalhes/relatorio-detalhes-local-execucao',
    view: 'relatorio-detalhes/relatorio-detalhes',
    meta: {
      keyAuthorized: 'relatorio',
    },
  },
  {
    path: '/relatorio-detalhe/:type/:period/:fontePagadoraId?/:status?',
    name: 'relatorio-detalhe',
    view: 'relatorio-detalhe',
    meta: {
      keyAuthorized: 'relatorio',
    },
  },
  {
    path: '/relatorio-pdf/:idFontePagadora/:dataInicial?/:dataFinal?',
    name: 'relatorio-pdf',
    view: 'relatorio-pdf',
    meta: {
      showMenu: false,
      keyAuthorized: 'relatorio',
    },
  },
  {
    path: '/relatorio-fonte-pagadora/:idFontePagadora/:dataInicial?/:dataFinal?',
    name: 'relatorio-fonte-pagadora',
    view: 'relatorio-fonte-pagadora',
    meta: {
      keyAuthorized: 'relatorio',
    },
  },
]

// -> ROTAS QUE PODEM SER DEFAULT <- //
// * Esse estado é utilizado para montar opções no cadastro/edição de usuários //
export const defaultRoutes = [
  {
    path: '/agendamento-medico',
    name: 'agendamentoMedico',
    view: 'agendamento-medico',
    meta: {
      showMenu: true,
      keyAuthorized: 'agendamento-medico',
    },
  },
  {
    path: '/backoffice/agencia-transfusional',
    name: 'BackofficeAgenciaTransfusional',
    view: 'backoffice-agencia-transfusional',
    meta: {
      showMenu: false,
      keyAuthorized: 'backoffice-agencia-transfusional',
      area: 'agenciatransfusional',
    },
  },
  {
    path: '/backoffice/agendamento',
    name: 'BackofficeAgendamento',
    view: 'backoffice-agendamento',
    meta: {
      showMenu: false,
      keyAuthorized: 'backoffice-agendamento',
      area: 'agendamento',
    },
  },
  {
    path: '/backoffice/autorizacao',
    name: 'BackofficeAutorizacao',
    view: 'backoffice-autorizacao',
    meta: {
      showMenu: false,
      keyAuthorized: 'backoffice-autorizacao',
      area: 'autorizacao',
    },
  },
  {
    path: '/backoffice/cadastro-medico',
    name: 'BackofficeCadastroMedico',
    view: 'backoffice-cadastro-medico',
    meta: {
      showMenu: false,
      keyAuthorized: 'backoffice-cadastro-medico',
    },
  },
  {
    path: '/backoffice/chat',
    name: 'BackofficeChat',
    view: 'backoffice-chat/backoffice-chat',
    meta: {
      showMenu: false,
      keyAuthorized: 'backoffice-chat',
    },
  },
  {
    path: '/backoffice/contratos',
    name: 'BackofficeContratos',
    view: 'backoffice-contratos',
    meta: {
      showMenu: false,
      keyAuthorized: 'backoffice-contratos',
    },
  },
  {
    path: '/backoffice/farmacia',
    name: 'BackofficeFarmacia',
    view: 'backoffice-farmacia',
    meta: {
      showMenu: false,
      keyAuthorized: 'backoffice-farmacia',
      area: 'farmacia',
    },
  },
  {
    path: '/backoffice/mapa-cirurgico',
    name: 'BackofficeMapaCirurgico',
    view: 'backoffice-mapa-cirurgico',
    meta: {
      showMenu: false,
      keyAuthorized: 'backoffice-mapa-cirurgico',
      area: 'agendamento',
    },
  },
  {
    path: '/backoffice/notificacoes',
    name: 'BackofficeNotificacoes',
    view: 'backoffice-notificacoes',
    meta: {
      showMenu: false,
      keyAuthorized: 'backoffice-notificacoes',
    },
  },
  {
    path: '/backoffice/orcamento',
    name: 'BackofficeOrcamento',
    view: 'backoffice-orcamento',
    meta: {
      showMenu: false,
      keyAuthorized: 'backoffice-orcamento',
      area: 'orcamento',
    },
  },
  {
    path: '/backoffice/power-bi',
    name: 'backofficePowerBi',
    view: 'backoffice-power-bi',
    meta: {
      showMenu: false,
      keyAuthorized: 'backoffice-power-bi',
      area: 'power-bi',
    },
  },
  {
    path: '/backoffice/pre-anestesico',
    name: 'BackofficePreAnestesico',
    view: 'backoffice-pre-anestesico',
    meta: {
      showMenu: false,
      keyAuthorized: 'backoffice-pre-anestesico',
      area: 'preanestesia',
    },
  },
  {
    path: '/backoffice/regulacao',
    name: 'BackofficeAutorizacao',
    view: 'backoffice-regulacao',
    meta: {
      showMenu: false,
      keyAuthorized: 'backoffice-regulacao',
      permissao: 'agendamento.backoffice.regulacao.listar',
      area: 'regulacao',
    },
  },
  {
    path: '/backoffice/suprimentos',
    name: 'BackofficeSuprimentos',
    view: 'backoffice-suprimentos',
    meta: {
      showMenu: false,
      keyAuthorized: 'backoffice-suprimentos',
      area: 'suprimentos',
    },
  },
  {
    path: '/backoffice/configuracao-de-sala',
    name: 'backofficeSurgeryRoomConfiguration',
    view: 'backoffice-configuracao-de-sala',
    meta: {
      showMenu: false,
      keyAuthorized: 'backoffice-configuracao-de-sala',
    },
  },
  {
    path: '/backoffice/mapa-cirurgico-grade',
    name: 'BackofficeMapaCirurgicoGrade',
    view: 'backoffice-mapa-cirurgico-grade',
    meta: {
      showMenu: false,
      keyAuthorized: 'backoffice-mapa-cirurgico-grade',
      area: 'agendamento',
    },
  },
  {
    path: '/backoffice/motivo-recusa-orcamento',
    name: 'BackofficeMotivoRecusaOrcamento',
    view: 'backoffice-motivo-recusa-orcamento',
    meta: {
      showMenu: false,
      keyAuthorized: 'backoffice-motivo-recusa-orcamento',
    },
  },
  {
    path: '/backoffice/operadora-convenio',
    name: 'BackofficeOperadoraConvenio',
    view: 'backoffice-operadora-convenio',
    meta: {
      showMenu: false,
      keyAuthorized: 'backoffice-operadora-convenio',
      permissao: 'agendamento.backoffice.fidelizacao.editarOperadoraConvenio',
      area: 'regulacao',
    },
  },
  {
    path: '/backoffice/procedimento-hospital-dia',
    name: 'BackofficeProcedimentoHospitalDia',
    view: 'backoffice-procedimento-hospital-dia',
    meta: {
      showMenu: false,
      keyAuthorized: 'backoffice-procedimento-hospital-dia',
    },
  },
  {
    path: '/backoffice/tempo-cirurgico-por-procedimento',
    name: 'BackofficeTempoCirurgicoPorProcedimento',
    view: 'backoffice-tempo-cirurgico-por-procedimento',
    meta: {
      showMenu: false,
      keyAuthorized: 'backoffice-tempo-cirurgico-por-procedimento',
      area: 'tempocirurgicoporprocedimento',
    },
  },
  {
    path: '/configuracoes/usuarios',
    name: 'ConfiguracaoUsuarios',
    view: 'configuracao-usuarios',
    meta: {
      showMenu: false,
      keyAuthorized: 'solicitacao-cirurgia',
    },
  },
  {
    path: '/backoffice/fidelizacao',
    name: 'BackofficeFidelizacao',
    view: 'operadora-fidelizacao',
    meta: {
      showMenu: false,
      keyAuthorized: 'operadora-fidelizacao',
      area: 'fidelizacao',
    },
  },
  {
    path: '/suporte/hospitais',
    name: 'SuporteHospitais',
    view: 'suporte-hospitais',
    meta: {
      showMenu: false,
      keyAuthorized: 'suporte',
    },
  },
  {
    path: '/financeiro',
    name: 'financeiro',
    view: 'financeiro',
    meta: {
      showMenu: false,
      keyAuthorized: 'financeiro',
    },
  },
  {
    path: '/financeiro-relatorio-perfil',
    name: 'financeiro-relatorio-perfil',
    view: 'financeiro-relatorio-perfil',
    meta: {
      showMenu: false,
      keyAuthorized: 'financeiro-relatorio-perfil',
    },
  },
  {
    path: '/financeiro-geracao-de-repasse',
    name: 'financeiroGeracaoDeRepasse',
    view: 'financeiro-geracao-de-repasse',
    meta: {
      showMenu: false,
      keyAuthorized: 'financeiro-geracao-de-repasses',
    },
  },
  {
    path: '/financeiro-tabela-pontuacao',
    name: 'financeiroTabelaSenioridade',
    view: 'financeiro-tabela-senioridade',
    meta: {
      showMenu: false,
      keyAuthorized: 'financeiro-tabela-senioridade',
    },
  },
  {
    path: '/recebimento-monitor',
    name: 'recebimentoMonitor',
    view: 'recebimento-monitor',
    meta: {
      showMenu: false,
      keyAuthorized: 'remuneracao-monitor',
    },
  },
  {
    path: '/integracao-geral-repasses',
    name: 'integracaoGeralRepasses',
    view: 'integracao-geral-repasses',
    meta: {
      showMenu: false,
      keyAuthorized: 'financeiro-integracao-geral-repasses',
    },
  },
  {
    path: '/financeiro-taxa-aluguel',
    name: 'financeiroTaxaAluguel',
    view: 'financeiro-taxa-aluguel',
    meta: {
      showMenu: false,
      keyAuthorized: 'financeiro-taxa-aluguel',
    },
  },
  {
    path: '/financeiro-imposto-prestador',
    name: 'financeiroImpostoPrestador',
    view: 'financeiro-imposto-prestador',
    meta: {
      showMenu: false,
      keyAuthorized: 'financeiro-imposto-prestador',
    },
  },
  {
    path: '/financeiro-gerenciamento-equipes',
    name: 'financeiroGerenciamentoEquipes',
    view: 'financeiro-gerenciamento-equipes',
    meta: {
      showMenu: false,
      keyAuthorized: 'financeiro-gerenciamento-equipes',
    },
  },
  {
    path: '/financeiro-antecipacao-recebiveis',
    name: 'financeiroAntecipacaoRecebiveis',
    view: 'financeiro-antecipacao-recebiveis',
    meta: {
      showMenu: false,
      keyAuthorized: 'financeiro-antecipacao-recebiveis',
    },
  },
  {
    path: '/financeiro-tabela-preco',
    name: 'financeiroTabelaPreco',
    view: 'financeiro-tabela-preco',
    meta: {
      showMenu: false,
      keyAuthorized: 'financeiro-tabela-propria',
    },
  },
  {
    path: '/financeiro-pontuacao-profissional',
    name: 'financeiroPontuacaoProfissional',
    view: 'financeiro-pontuacao-profissional',
    meta: {
      showMenu: false,
      keyAuthorized: 'financeiro-pontuacao-profissional',
    },
  },
  {
    path: '/financeiro-carga-remuneracao',
    name: 'financeiroCargaRemuneracao',
    view: 'financeiro-carga-remuneracao',
    meta: {
      showMenu: false,
      keyAuthorized: 'financeiro-carga-remuneracao',
    },
  },
  {
    path: '/financeiro/cadastro/grupo-hospital',
    name: 'FinanceiroCadastroGrupoHospital',
    view: 'financeiro-cadastro-grupo-hospital',
    meta: {
      showMenu: false,
      isAuthorized: true,
      keyAuthorized: 'financeiro-adm-hospitais',
    },
  },
  {
    path: '/suporte/contratos',
    name: 'SuporteContratos',
    view: 'suporte-contratos',
    meta: {
      showMenu: false,
      keyAuthorized: 'financeiro-suporte-contratos',
    },
  },
  {
    path: '/suporte/contratos/:id',
    name: 'SuporteContratosDetails',
    view: 'suporte-contratos-details',
    meta: {
      showMenu: false,
      keyAuthorized: 'financeiro-suporte-contratos',
    },
  },
  {
    path: '/suporte/usuarios',
    name: 'SuporteUsuarios',
    view: 'suporte-usuarios',
    meta: {
      showMenu: false,
      keyAuthorized: 'financeiro-suporte-usuarios',
    },
  },
  {
    path: '/suporte/grupo-repasses',
    name: 'SuporteGrupoRepasse',
    view: 'suporte-grupo-repasses',
    meta: {
      showMenu: false,
      keyAuthorized: 'financeiro-suporte-grupo-repasses',
    },
  },
  {
    path: '/financeiro-regras-calculo',
    name: 'financeiroRegrasProfissional',
    view: 'financeiro-regras-profissional',
    meta: {
      showMenu: false,
      keyAuthorized: 'backoffice-calculo-regra-profissional',
    },
  },
  {
    path: '/financeiro-recalcular-procedimentos',
    name: 'financeiroRecalcularProcedimentos',
    view: 'financeiro-recalcular-procedimentos',
    meta: {
      showMenu: false,
      keyAuthorized: 'financeiro-recalcular-procedimentos',
    },
  },
  {
    path: '/financeiro-download-notas',
    name: 'FinanceiroDownloadNotas',
    view: 'financeiro-download-notas',
    meta: {
      showMenu: false,
      keyAuthorized: 'financeiro-download-notas',
    },
  },
  {
    path: '/financeiro-cadastro-layout-email',
    name: 'financeiroCadastroLayoutEmail',
    view: 'financeiro-cadastro-layout-email',
    meta: {
      showMenu: false,
      keyAuthorized: 'financeiro-cadastro-layout-email',
    },
  },
  {
    path: '/financeiro-garantia-minima-global',
    name: 'financeiroGarantiaMinimaGlobal',
    view: 'financeiro-garantia-minima-global',
    meta: {
      showMenu: false,
      keyAuthorized: 'financeiro-calculo-garantia-minima-global',
    },
  },
  {
    path: '/backoffice/comorbidades',
    name: 'BackofficeComorbidades',
    view: 'backoffice-comorbidades',
    meta: {
      showMenu: false,
      keyAuthorized: 'backoffice-comorbidades',
    },
  },
]

export default [
  ...backofficeRoutes,
  ...financeiroRoutes,
  ...configuracaoRoutes,
  ...suporteRoutes,
  ...relatorioRoutes,
  ...defaultRoutes,
  {
    path: '/inicio',
    name: 'inicio',
    view: 'inicio',
    meta: {
      isPublic: true,
      showMenu: false,
      isAuthorized: true,
      keyAuthorized: 'inicio',
    },
  },
  {
    path: '/home',
    name: 'home',
    view: 'home-transitoria',
    meta: {
      showMenu: true,
      isAuthorized: true,
      keyAuthorized: 'home',
    },
  },
  {
    path: '/logout',
    name: 'logout',
    view: 'logout',
    meta: {
      // Sem isPublic, o redirect() do App.vue dispara Auth.login() quando o token
      // local já expirou — reautentica em silêncio em vez de deixar o logout rodar.
      isPublic: true,
      showMenu: false,
      isAuthorized: true,
      keyAuthorized: 'logout',
    },
  },
  {
    // Logout por link direto (pode ser enviado ao usuário fora do app).
    // Precisa ser pública: funciona mesmo com o token local já expirado.
    path: '/sair',
    name: 'sair',
    view: 'sair',
    meta: {
      isPublic: true,
      showMenu: false,
      isAuthorized: true,
      keyAuthorized: 'sair',
    },
  },
  {
    path: '/navigation-not-allowed',
    name: 'NoDefaultRoute',
    view: 'no-default-route',
    meta: {
      showMenu: false,
      isAuthorized: true,
      keyAuthorized: '',
    },
  },
  {
    path: '/no-content',
    name: 'NoContent',
    view: 'no-content',
    meta: {
      showMenu: false,
      isAuthorized: true,
      keyAuthorized: '',
    },
  },
  {
    path: '/token-exchange/:uuid?/:identificador?',
    name: 'TokenExchange',
    view: 'token-exchange',
    meta: {
      isPublic: true,
      showMenu: false,
    },
  },
  {
    path: '/perfil',
    name: 'perfil',
    view: 'perfil',
    meta: {
      isAuthorized: true,
      keyAuthorized: 'perfil',
    },
  },
  {
    path: '/perfil/documentos',
    name: 'profile-documents',
    view: 'profile-documents',
    meta: {
      isAuthorized: true,
      keyAuthorized: 'perfil',
    },
  },
  {
    path: '/perfil/hospital/documentos',
    name: 'hospital-profile-documents',
    view: 'hospital-profile-documents',
    meta: {
      isAuthorized: true,
      keyAuthorized: 'perfil',
    },
  },
  {
    path: '/ajuda',
    name: 'ajuda',
    view: 'ajuda',
    meta: {
      isAuthorized: true,
      keyAuthorized: 'perfil',
    },
  },
  {
    path: '/cadastro-medico/:tipoConvite/:conviteId',
    name: 'cadastroMedico',
    view: 'cadastro-medico',
    meta: {
      isPublic: true,
      isAuthorized: true,
      showMenu: false,
      keyAuthorized: 'cadastro-medico-convite',
    },
  },
  {
    path: '/assinatura/:conviteId/:backpage?',
    name: 'assinatura',
    view: 'assinatura',
    meta: {
      isPublic: true,
      isAuthorized: true,
      showMenu: false,
      keyAuthorized: 'assinatura',
    },

  },
  {
    path: '/producao',
    name: 'producao',
    view: 'producao',
    meta: {
      showMenu: true,
      keyAuthorized: 'producao',
    },
  },
  {
    path: '/producao-filtro',
    name: 'producao-filtro',
    view: 'ProducaoFiltro',
    meta: {
      keyAuthorized: 'producao',
    },
  },
  {
    path: '/producao-impressao/:producaoId',
    name: 'ProducaoImpressao',
    view: 'ProducaoImpressao',
    meta: {
      showMenu: false,
      keyAuthorized: 'producao',
    },
  },
  {
    path: '/plantao/:action?/:plantaoId?',
    name: 'Plantao',
    view: 'plantao',
    meta: {
      showMenu: false,
      keyAuthorized: 'plantao',
    },
  },
  {
    path: '/provisao/:action?/:producaoid?',
    name: 'provisao',
    view: 'provisao',
    meta: {
      keyAuthorized: 'provisao',
    },
  },
  {
    path: '/provisao-aprovar',
    name: 'provisao-aprovar',
    view: 'provisao-aprovar',
    meta: {
      keyAuthorized: 'provisao',
    },
  },
  {
    path: '/provisao-filtrar',
    name: 'provisao-filtrar',
    view: 'provisao-filtrar',
    meta: {
      keyAuthorized: 'provisao',
    },
  },
  {
    path: '/recebimento',
    name: 'Recebimento',
    view: 'recebimento',
    meta: {
      showMenu: true,
      keyAuthorized: 'recebimento',
    },
  },
  {
    path: '/recebimento-detalhe/:contratoId/:data',
    name: 'RecebimentoDetalhe',
    view: 'recebimento-detalhe',
    meta: {
      showMenu: false,
      keyAuthorized: 'recebimento',
    },
  },
  {
    path: '/calculadora',
    name: 'calculadora',
    view: 'calculadora',
    meta: {
      showMenu: false,
      isPublic: true,
      acao: 'Alterar',
      keyAuthorized: 'calculadora',
    },
  },
  {
    path: '/consulta-autorizacao/:medicoId?/:hospitalId?/:convenioId?',
    name: 'ConsultaAutorizacao',
    view: 'consulta-autorizacao',
    meta: {
      showMenu: false,
      keyAuthorized: 'agendamento-medico',
    },
  },
  {
    path: '/solicitacao-cirurgia/:solicitacaoId/:hospitalId/:medicoId/:medico',
    name: 'SolicitacaoCirurgia',
    view: 'solicitacao-cirurgia',
    meta: {
      showMenu: false,
      keyAuthorized: 'agendamento-medico',
    },
  },
  {
    path: '/solicitacao-cirurgia-details/:solicitacaoId/:hospitalId/:medicoId/:medico',
    name: 'SolicitacaoCirurgiaDetails',
    view: 'solicitacao-cirurgia',
    meta: {
      showMenu: false,
      keyAuthorized: 'agendamento-medico',
    },
  },
  {
    path: '/aceite',
    name: 'aceite',
    view: 'aceite',
    meta: {
      showMenu: false,
      isAuthorized: true,
      keyAuthorized: 'aceite',
    },
  },
  {
    path: '/login',
    name: 'login',
    view: 'login',
    meta: {
      isPublic: true,
      showMenu: false,
      isAuthorized: true,
      keyAuthorized: 'login',
    },
  },
  {
    path: '/politica-de-privacidade',
    name: 'politica-de-privacidade',
    view: 'politica-de-privacidade',
    meta: {
      isPublic: true,
      showMenu: false,
      isAuthorized: true,
      keyAuthorized: 'politica-privacidade',
    },
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    view: 'dashboard',
    meta: {
      showMenu: true,
      keyAuthorized: 'dashboard',
    },
  },
  {
    path: '/termos-de-uso',
    name: 'termos-de-uso',
    view: 'termos-de-uso',
    meta: {
      isPublic: true,
      showMenu: false,
      isAuthorized: true,
      keyAuthorized: 'termos-uso',
    },
  },
  {
    path: '/termos-de-uso/hospital/:hospitalId',
    name: 'hospital-terms-of-use',
    view: 'hospital-terms-of-use',
    meta: {
      isPublic: true,
      showMenu: false,
      isAuthorized: true,
      keyAuthorized: 'termos-uso',
    },
  },
  {
    path: '/503',
    name: 'service-unavaliable',
    view: 'service-unavaliable',
    meta: {
      isPublic: true,
      showMenu: false,
      isAuthorized: true,
    },
  },
  {
    path: '/404',
    name: 'not-found',
    view: 'not-found',
    meta: {
      isPublic: true,
      showMenu: false,
      isAuthorized: true,
      keyAuthorized: 'not-found',
    },
  },
  {
    path: '/403',
    name: 'forbidden',
    view: 'forbidden',
    meta: {
      isPublic: true,
      showMenu: false,
      isAuthorized: true,
      keyAuthorized: 'forbidden',
    },
  },
]
